import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesAssignResourceColumnsModel} from "../../models/services-assign-resource-columns.model";
import {MissingItemDataModel, MissingItemModel} from "../../models/missing-item.model";
import {OperationalContactModel} from "../../../commons/angular/models/operational-contact.model";

export class ServiceOperationalContactsTableComponent implements IController {
  operationalContacts: OperationalContactModel[];
  quantityLeft?: number;
  onRemove: Function;
  onChange: Function;

  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  setEvents() {
    const div1 = document.getElementById('service-operational-contacts-table').querySelectorAll("#header")[0];
    const div2 = document.getElementById('service-operational-contacts-table').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceOperationalContactsTable', {
    require: {
      form: '^form'
    },
    bindings: {
      operationalContacts: '<',
      onRemove: '&',
      onChange: '&'
    },
    template: require('./service-operational-contacts-table.html').default,
    controller: ServiceOperationalContactsTableComponent
  });
